module.exports = __webpack_public_path__ + "static/11import-b33f076d80046c7c5ac6a354ecab7106.png";